import React, { useCallback } from 'react';
import { connect } from 'react-redux';

import EditNumberView from 'views/Administration/HiredNumber/EditNumber';
import AccountDirectDialService from 'api/AccountDirectDial';
import SettingsActions from 'store/reducers/Settings';
import { useSubmit, useFetch } from 'hooks';
import { handlePromise } from 'utils';

const EditNumber = ( {
  entityId,
  open,
  onClose,
  onConfirm,
  toggleLoading,
  toggleErrorAlert,
} ) => {
  const [data, dataLoading] = useFetch( {
    initialState: {},
    promise: () => AccountDirectDialService.getDdi( entityId ),
    toggleErrorAlert,
    conditional: !!entityId && open,
    deps: [entityId, open],
    reInit: true,
  } );

  const submitForm = useSubmit( {
    promise: ( dataToSend ) => {
      const formatData = {
        ...dataToSend,
        isSendEmail: dataToSend.isSendEmail ? 1 : 0,
      };
      return AccountDirectDialService.updateDdi( entityId, formatData );
    },
    toggleLoading,
    callback: onConfirm,
  } );

  const unsubscribeNumber = useCallback(
    async ( callback ) => {
      toggleLoading( true );

      const [errors, response] = await handlePromise(
        AccountDirectDialService.deleteDdi( entityId ),
      );
      toggleLoading( false );
      if ( !response.ok ) return toggleErrorAlert( errors );

      callback();
      onConfirm();
    },
    [entityId, onConfirm, toggleLoading, toggleErrorAlert],
  );

  return (
    <EditNumberView
      data={data}
      isLoading={dataLoading}
      open={open}
      onSubmit={submitForm}
      onClose={onClose}
      onUnsubscribeNumber={unsubscribeNumber}
    />
  );
};

const mapDispatchToProps = {
  toggleLoading: SettingsActions.toggleLoading,
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
};

export default connect( null, mapDispatchToProps )( EditNumber );
